import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

export type CreditorCatalogState = {
  banks: GeneralCatalogItem[];
  creditCardBanks: GeneralCatalogItem[];
};

const initialState: CreditorCatalogState = {
  banks: [],
  creditCardBanks: [],
};

const creditorCatalogSlice = createSlice({
  name: 'creditorCatalog',
  initialState,
  reducers: {
    overwriteCreditorCatalog: (
      _,
      action: PayloadAction<CreditorCatalogState>,
    ): CreditorCatalogState => {
      return action.payload;
    },
    updateBanks: (state, action: PayloadAction<GeneralCatalogItem[]>): void => {
      state.banks = action.payload;
    },
    updateCreditCardBanks: (
      state,
      action: PayloadAction<GeneralCatalogItem[]>,
    ): void => {
      state.creditCardBanks = action.payload;
    },
  },
});

export const { overwriteCreditorCatalog, updateBanks, updateCreditCardBanks } =
  creditorCatalogSlice.actions;

export default creditorCatalogSlice.reducer;
